module.exports = function () {
    return function (quantity, size) {
        return quantity
            ? quantity + ' ' + size
            : `0.0 ${size}`;
    };
};

//module.exports = function () {
//    return function (quantity, size) {
//        if (quantity && quantity > 0) {
//            return quantity + ' ' + size;
//        } else {
//            return '-';
//        }
//    };
//};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/filters/wow-nutrition-filter.js
 **/